import React from "react";
import ratingEmpty from "./img/rating-empty-18.svg";
import ratingFull from "./img/rating-full-18.svg";
interface RatingProps {
  ratingData: number;
}
const Rating: React.FC<RatingProps> = ({ ratingData }) => {
  const percentage = (ratingData / 5) * 100;

  return (
    <div
      className="position-relative overflow-hidden"
      style={{ width: "106px", height: "18px" }}
    >
      <img
        className="rating-overlay position-absolute start-50 translate-middle"
        alt="star-empty"
        style={{ width: "106px", height: "18px" }}
        src={ratingEmpty}
      />
      <div
        style={{
          left: `${percentage}%`,
          width: "106px",
          height: "18px",
          background: "#fff",
        }}
        className="rating-full bottom-0 position-absolute"
      ></div>
      <img
        className="rating-empty position-absolute start-50 translate-middle"
        alt="star-full"
        style={{ width: "106px", height: "18px" }}
        src={ratingFull}
      />
    </div>
  );
};
export default Rating;
